import { useQuery } from 'react-query';

import { getRecord } from '../utils/backend-api/universal';

export const NEWSLETTER_KEY = 'NEWSLETTER';

export interface Newsletter {
  accessLevel: number;
  cardImageUrlImgix: string;
  description: string;
  frequency: string;
  id: number | string;
  landingPageDescription: string;
  name: string;
  slug: string;
  author: { name: string };
  offer: { code: string };
}

export default function useCurrentNewsletter(newsletterId: number) {
  const { data } = useQuery<{ result: Newsletter }>(
    NEWSLETTER_KEY,
    async () =>
      await getRecord({
        id: newsletterId,
        model: 'Newsletter',
        attributes: [
          'accessLevel',
          'description',
          'frequency',
          'id',
          'landing_page_description',
          'name',
        ],
        helpers: ['card_image_url_imgix', 'slug'],
        relations: {
          author: { attributes: ['name'] },
          offer: { attributes: ['code'] },
        },
      })
  );

  return { newsletter: data?.result };
}
